"use strict";

var $ = require("jquery");
var common = require("./common");

var EMAIL_KEYUP_ABLE = true;

function InvalidTokenResetPassword (params) {
    this.resetPasswordWidgetInstance = params.resetPasswordWidgetInstance;
    this.environment = params.environment;
    this.apigeeKey = params.apigeeKey;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/passwords/reset-requests';
    this.locale = params.language;
}

InvalidTokenResetPassword.prototype.init = function (requestId) {
    var self = this;
    this.invalidTokenResetParent = this.resetPasswordWidgetInstance.invalidTokenParent.find(".invalidToken-forgot-password");
    this.clearErrorMessages();
    if(this.resetPasswordWidgetInstance.token != null && this.resetPasswordWidgetInstance.token != ""
        && this.resetPasswordWidgetInstance.token != true)
    {
        common.showElement(this.invalidTokenResetParent.find("#invalid-token"));
        common.hideElement(this.invalidTokenResetParent.find("#no-token"));
    } else {
        common.hideElement(this.invalidTokenResetParent.find("#invalid-token"));
        common.showElement(this.invalidTokenResetParent.find("#no-token"));
    }
    this.emailField = this.invalidTokenResetParent.find("input#uim-uEmail-input");
    var submit = this.invalidTokenResetParent.find("input#uim-invalidToken-submit");
    var emailInputErrors = this.invalidTokenResetParent.find("#email-input-errors");
    this.fields = {
        email: this.emailField
    };

	this.emailField.on("focus", function () {
		var isEmptyEmail = self.fields.email.val().length === 0;
		if(isEmptyEmail){
			EMAIL_KEYUP_ABLE = true;
			$("div#email-input-area").removeClass("error");
			common.hideElement(emailInputErrors.find(".uim-message.empty-email-input"));
			common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
		}
    });

    this.emailField.on("blur", function () {
		self.validateEmail();
        if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
           // EMAIL_KEYUP_ABLE = self.validateEmail();
        } else {
            common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
        }
        self.updateSubmitState();
    });

    this.emailField.on("keyup", function () {
        if(!EMAIL_KEYUP_ABLE){
			if(common.validateRequiredField(self.emailField,emailInputErrors,".uim-message.empty-email-input")) {
				EMAIL_KEYUP_ABLE = self.validateEmail();
			} else {
				common.hideElement(emailInputErrors.find(".uim-message.invalid-email-input"));
			}
			self.validateEmail();
		}
        self.updateSubmitState();
    });
    submit.off("click enter");
    submit.on("click enter", function (e) {
        e.preventDefault();
        self.forgotPassword({
            email: self.fields.email.val(),
            requestId: requestId
        });
    });

};

InvalidTokenResetPassword.prototype.updateSubmitState = function() {
    if(this.fields.email.val().length !== 0 && !this.checkValidationErrors()) {
        this.invalidTokenResetParent.find("input#uim-invalidToken-submit").removeAttr('disabled');
    } else {
        this.invalidTokenResetParent.find("input#uim-invalidToken-submit").attr("disabled", true);
    }
};

InvalidTokenResetPassword.prototype.checkValidationErrors = function() {
    var submitErrorsElement = this.invalidTokenResetParent.find("#sendGridSubmit-errors");
    var emailInputErrorsElement = this.invalidTokenResetParent.find("#email-input-errors");
    return (
        common.checkElement(submitErrorsElement.find(".uim-message.unknown_server_error")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.invalid-email-input")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.empty-email-input")));
};

InvalidTokenResetPassword.prototype.validateEmail = function() {
    var isValid = this.emailField[0].validity.valid;
    var email = this.invalidTokenResetParent.find("input#uim-uEmail-input");
    var emailInputErrorsElement = this.invalidTokenResetParent.find("#email-input-errors");

	var isEmptyEmail = email[0].value.length === 0;
	if (isEmptyEmail) {
        email.parent().removeClass("error");
        common.hideElement(emailInputErrorsElement.find(".uim-message.empty-email-input"));
		common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
        //this.clearErrorMessages();
		EMAIL_KEYUP_ABLE = true;
    }else if(isValid){
        email.parent().removeClass("error");
        common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = true;
    } else {
        email.parent().addClass("error");
        common.showElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
		EMAIL_KEYUP_ABLE = isValid;
    }
    return isValid;

};

InvalidTokenResetPassword.prototype.clearErrorMessages = function () {
    var submitErrorsElement = this.invalidTokenResetParent.find("#sendGridSubmit-errors");
    var emailInputErrorsElement = this.invalidTokenResetParent.find("#email-input-errors");

    common.hideElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"));
    common.hideElement(emailInputErrorsElement.find(".uim-message.empty-email-input"));
};

InvalidTokenResetPassword.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.invalidTokenResetParent.find("#invalidSubmit-errors");
    common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
};

InvalidTokenResetPassword.prototype.showSuccessMsg = function () {
    if(this.resetPasswordWidgetInstance.token != null && this.resetPasswordWidgetInstance.token != "")
    {
        common.showElement(this.invalidTokenResetParent.find("#invalidTokenSuccess"));
        common.hideElement(this.invalidTokenResetParent.find("#noTokenSuccess"))
    } else {
        common.hideElement(this.invalidTokenResetParent.find("#invalidTokenSuccess"));
        common.showElement(this.invalidTokenResetParent.find("#noTokenSuccess"));
    }
};

InvalidTokenResetPassword.prototype.forgotPassword = function(params){
    var myReturnURL = "undefined" != typeof getUrlParameter("returnURL") ? getUrlParameter("returnURL") : "";
    var self = this;
    $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: JSON.stringify({
            data : {
                type : "password-reset-request",
                attributes : {
                    emailAddress : self.fields.email.val(),
                    locale: self.locale,
                    returnURL: myReturnURL
                }
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": params.requestId
        }
    }).success(function(data, status) {
        self.showSuccessMsg();
    }).error(function(xhr) {
        self.showInputErrors(xhr.status);
    });
};

module.exports = InvalidTokenResetPassword;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/invalidToken-forgot-password.js
// module id = 21
// module chunks = 0